<template>
  <router-view/>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import {
  bootstrapXInstall,
  bindXInstallClickDelegation,
  handleJumpRealLinkInApp,
  isNativeAppUserAgent,
} from '@/utils/xinstallOpenWebView'

let unbindXInstallClick = null

onMounted(() => {
  if (isNativeAppUserAgent()) {
    handleJumpRealLinkInApp()
    return
  }
  bootstrapXInstall()
  unbindXInstallClick = bindXInstallClickDelegation()
})

onUnmounted(() => {
  unbindXInstallClick?.()
  unbindXInstallClick = null
})
</script>

<style>
</style>
